<template>
  <div class="sidebar-page-wrapper">
    <div
      class="sidebar-menu-bg"
      v-if="menuBg && $root.screenWidth > 550"
      :style="{ 'background-image': `url(${menuBg})` }"
    ></div>
    <div
      class="sidebar"
      :style="{
        'background-image': $root.screenWidth <= 550 ? `url(${menuBg})` : ''
      }"
    >
      <el-menu
        router
        :default-active="$route.path"
        class="sidebar-menu manage-sidebar-menu"
        :mode="$root.screenWidth > 550 ? 'vertical' : 'horizontal'"
      >
        <el-submenu
          index="/manage/organisation-profile"
          v-if="
            p('Manage Module.Organisation.Buildings & Rooms.View') ||
              p('Manage Module.Organisation.Manufacturers.View') ||
              p('Manage Module.Organisation.Network Map.View') ||
              p('Manage Module.Organisation.Settings.View') ||
              p('Manage Module.Organisation.Roles & Permissions.View') ||
              p('Manage Module.Organisation.Profile.Save')
          "
        >
          <template slot="title">
            <span>{{ $t('text.organisation').toUpperCase() }}</span>
          </template>
          <el-menu-item
            index="/manage/organisation-profile"
            v-if="p('Manage Module.Organisation.Profile.Save')"
            >{{ $t('text.profile') }}</el-menu-item
          >
          <el-menu-item
            index="/manage/buildings-rooms"
            v-if="p('Manage Module.Organisation.Buildings & Rooms.View')"
            >{{ $t('text.Buildings & Rooms') }}</el-menu-item
          >
          <el-menu-item
            index="/manage/manufacturers"
            v-if="p('Manage Module.Organisation.Manufacturers.View')"
            >{{ $t('text.Manufacturers') }}</el-menu-item
          >
          <el-menu-item
            index="/manage/network-map"
            v-if="p('Manage Module.Organisation.Network Map.View')"
          >
            <span slot="title">{{ $t('text.network_map') }}</span>
          </el-menu-item>
          <!-- <el-menu-item index="/manage/network-utilisation">
            <span slot="title">{{
              $t('text.network_utilisation')
            }}</span>
          </el-menu-item> -->
          <el-menu-item
            index="/manage/admin-permissions"
            v-if="p('Manage Module.Organisation.Roles & Permissions.View')"
            >{{ $t('text.Roles & Permissions') }}</el-menu-item
          >
          <el-menu-item
            index="/manage/organisation-setting"
            v-if="p('Manage Module.Organisation.Settings.View')"
            >{{ $t('text.settings') }}</el-menu-item
          >
        </el-submenu>
        <el-menu-item
          index="/manage/my-account"
          v-if="
            p('Manage Module.Account.Save') || p('Manage Module.Account.Delete')
          "
        >
          <span slot="title">{{ $t('text.account').toUpperCase() }}</span>
        </el-menu-item>
        <el-submenu
          index="/manage/user-accounts"
          v-if="
            p('Manage Module.Users.User Accounts.View') ||
              p('Manage Module.Users.Invite User.Save')
          "
        >
          <template slot="title">
            <span>{{ $t('text.users').toUpperCase() }}</span>
          </template>
          <el-menu-item
            index="/manage/user-accounts"
            v-if="p('Manage Module.Users.User Accounts.View')"
            >{{ $t('text.user_accounts') }}</el-menu-item
          >
          <el-menu-item
            index="/manage/invite-user"
            v-if="p('Manage Module.Users.Invite User.Save')"
            >{{ $t('text.invite_user') }}</el-menu-item
          >
        </el-submenu>
        <el-submenu
          index="/manage/patient-list"
          v-if="
            p('Manage Module.Patients.Patients Module.View') ||
              p('Manage Module.Patients.Patient Data Privacy.Archive') ||
              p('Manage Module.Patients.Patient Data Privacy.Restore') ||
              p('Manage Module.Patients.Patient Data Privacy.Delete')
          "
        >
          <template slot="title">
            <span>{{ $t('text.patients').toUpperCase() }}</span>
          </template>
          <el-menu-item
            index="/manage/patient-list"
            v-if="p('Manage Module.Patients.Patients Module.View')"
            >{{ $t('text.patients') }}</el-menu-item
          >
          <el-menu-item
            index="/manage/data-privacy"
            v-if="
              p('Manage Module.Patients.Patient Data Privacy.Archive') ||
                p('Manage Module.Patients.Patient Data Privacy.Restore') ||
                p('Manage Module.Patients.Patient Data Privacy.Delete')
            "
          >
            <span slot="title">{{ $t('text.Data Privacy') }}</span>
          </el-menu-item>
        </el-submenu>
        <el-submenu
          index="/manage/devices-pods"
          v-if="
            p('Manage Module.Devices.Nodes.View') ||
              p('Manage Module.Devices.Pods Location.View')
          "
        >
          <template slot="title">
            <span>{{ $t('text.Devices').toUpperCase() }}</span>
          </template>
          <el-menu-item
            index="/manage/devices-pods"
            v-if="p('Manage Module.Devices.Pods Location.View')"
            >{{ $t('text.pods') }}</el-menu-item
          >
          <el-menu-item
            index="/manage/devices-nodes"
            v-if="p('Manage Module.Devices.Nodes.View')"
          >
            <span slot="title">{{ $t('text.nodes') }}</span>
          </el-menu-item>
        </el-submenu>
        <el-submenu
          index="/manage/report"
          v-if="
            p('Manage Module.Report.Export.Save') ||
              p('Manage Module.Report.History.View')
          "
        >
          <template slot="title">
            <span>{{ $t('text.report').toUpperCase() }}</span>
          </template>
          <el-menu-item
            index="/manage/report"
            v-if="p('Manage Module.Report.Export.Save')"
            >{{ $t('text.export') }}</el-menu-item
          >
          <el-menu-item
            index="/manage/report-history"
            v-if="p('Manage Module.Report.History.View')"
            >{{ $t('text.history') }}</el-menu-item
          >
        </el-submenu>
        <el-submenu
          index="/manage/admin-algorithms"
          v-if="
            p('Manage Module.Super Admin.Algorithms.View') ||
              p('Manage Module.Super Admin.Data Privacy.Save') ||
              p('Manage Module.Super Admin.Customisation.Save')
          "
        >
          <template slot="title">
            <span>{{ $t('text.super_admin').toUpperCase() }}</span>
          </template>
          <el-menu-item
            index="/manage/admin-algorithms"
            v-if="p('Manage Module.Super Admin.Algorithms.View')"
            >{{ $t('text.algorithms') }}</el-menu-item
          >
          <el-menu-item
            index="/manage/admin-data-privacy"
            v-if="p('Manage Module.Super Admin.Data Privacy.Save')"
            >{{ $t('text.data_privacy') }}</el-menu-item
          >
          <el-menu-item
            index="/manage/admin-customization"
            v-if="p('Manage Module.Super Admin.Customisation.Save')"
            >{{ $t('text.customization') }}</el-menu-item
          >
        </el-submenu>
      </el-menu>
    </div>
    <div class="sidebar-type-page-content">
      <PatientFilter
        :showPatientBox="false"
        v-if="$route.path === '/manage/network-map'"
      />
      <Helper v-if="$route.path !== '/manage/landing'" />
      <router-view ref="content" />
    </div>
  </div>
</template>

<script>
import Helper from '@/components/Helper.vue'
import PatientFilter from '@/components/dashboard/PatientFilter.vue'
export default {
  components: {
    Helper,
    PatientFilter
  },
  computed: {
    menuBg() {
      return this.$store.state.customization.menuBg
    }
  }
}
</script>
